import {isDate} from 'lodash';

export function datesToSpan(start: Date, end: Date): string {
    const ms = end.getTime() - start.getTime();
    if (ms < 1000) return '<1s';

    let sec = Math.round(ms / 1000);
    if (sec < 60) return `${sec}s`;

    let min = Math.round(sec / 60);
    sec = sec % 60;
    return `${min}m${sec}s`;
}

export function dateOnlyToDateTime(dt: string | Date): Date {
    if (!dt) return null;

    const newDate = isDate(dt) ? dt : new Date(dt);
    newDate.setHours(newDate.getHours() + 10);
    return newDate;
}

export function escapeRegex(str: string): string {
    return str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
